import { ChangeDetectorRef, Component } from '@angular/core';
import { AppService } from '../../app.service';
import { catchError, finalize, firstValueFrom, pipe, tap } from 'rxjs';
import { isArrayWithData } from '../../utilities/array.helpers';
import { CreditorService } from '../../services/creditor/creditor.service';
import {
    DATE_FORMATS,
    PHONE_NUMBER_PREFIXES,
    TIME_ZONES,
} from '../../constants/constants';
import {
    INITIAL_CREDITOR_FORM,
    VALIDATION_ERRORS,
} from './creditor-form.constant';
import {
    isArray,
    isObject,
    isValidEmail,
    isValidPhoneNumber,
    isValidWebsite,
} from '../../utilities/validation.helpers';
import { DropdownOption } from '../../interfaces/dropdown-option.interface';

@Component({
    selector: 'app-manage-creditors',
    templateUrl: './add-edit-creditor.component.html',
    styleUrl: './add-edit-creditor.component.css',
})
export class AddEditCreditorComponent {
    isArray = isArray;
    isObject = isObject;

    PHONE_NUMBER_PREFIXES = PHONE_NUMBER_PREFIXES;
    DATE_FORMATS = DATE_FORMATS;
    TIME_ZONES = TIME_ZONES;

    industryOptions!: DropdownOption[];
    paymentTypeOptions!: DropdownOption[];

    isSideBarVisible: boolean = false;

    creditorForm: any = INITIAL_CREDITOR_FORM;

    creditors!: any[];

    firstName: string = '';
    lastName: string = '';
    email: string = '';

    rows: number = 10;

    paymentPlans: any[] = [
        {
            Frequency: 0,
            MinAmount: 100,
            Enable: true,
        },
        {
            Frequency: 1,
            MinAmount: 150,
            Enable: true,
        },
        {
            Frequency: 2,
            MinAmount: 150,
            Enable: true,
        },
    ];

    contactPoints: any[] = [
        {
            ButtonText: 'Call Now',
            ContactNumber: '8002353275',
        },
    ];

    isShowField: any = {};

    validationErrors: any = {};
    fetchCount: number = 0;
     selectedCreditorId: string = '';
    creditorCompanyName: string = '';
    formSelectedCreditorId: string = '';
    formCreditorCompanyName: string = '';
    originalCreditors: any[] = [];

    creditorSample: any = {
        BlobStorageName: 'moneystash',
        AlertsEmailAddress: 'client_success@remitter.com',
        TimeZone: 'Central Standard Time',
        CompanyName: 'Money Stash',
        Website: 'www.moneystash.com',
        CallbackEmailAddress: 'client_success@remitter.com',
        CallbackPhoneNumber: '8002353275',
        PaymentPortalUrl: 'https://pay.moneystash.com',
        DaysAfterDueTillDefault: '120',
        EnableInvoiceChallenge: false,
        BaselineDebtAgeToUploadDate: true,
        DebitCardGateWay: 0,
        BankAccountGateWay: 0,
        PaypalGateWay: 0,
        EnablePaymentPlans: true,
        EnablePartialPayments: false,
        ToggleCompletePaymentPlanOnInitialEndDate: false,
        RepaymentWindowInDays: 112,
        MinimumAllowableInvoiceAmountForPartial: 100,
        MinimumAllowablePartialAmount: 100,
        MinimumAllowableInvoiceAmountForPaymentPlan: 0,
        BypassPolicySystem: true,
        ForceDefaultLanguage: false,
        IndustryVertical: 'NonBankLender',
        SendPaymentPlanEmailReminder: true,
        SendPaymentPlanSmsReminder: true,
        CountryPhoneNumberPrefix: '+1',
        IsActive: true,
        DateFormat: 'MM/dd/yyyy',

        //-- Not yet saved:
        CreditorContactPoint: [
            {
                ButtonText: 'Call Now',
                ContactNumber: '8002353275',
            },
        ],
        WebsiteDesktopLogo:
            'https://remitterprod.blob.core.windows.net/logos/MoneyStash_Logo.png',
        WebsiteMobileLogo:
            'https://remitterprod.blob.core.windows.net/logos/MoneyStash_Logo.png',
        WebsiteEmailLogo:
            'https://remitterprod.blob.core.windows.net/logos/MoneyStash_Logo.png',
        WebsiteLegalActionText: '',
        WebsiteOutstandingText: 'You have an outstanding balance',
        WebsiteTermsAndConditions: '',

        CreditorPortalUrl: 'https://admin.remitter.com',
        FailedPaymentRetryEnabled: false,
        FailedPaymentRetryMaximumRetry: 1,
        FailedPaymentRetryIntervalInHours: 24,
        FailedPaymentRetryEndPaymentPlan: false,
        SupportContactNumber: '',
        PaymentPlans: [
            {
                Frequency: 0,
                MinAmount: 100,
                Enable: true,
            },
            {
                Frequency: 1,
                MinAmount: 150,
                Enable: true,
            },
            {
                Frequency: 2,
                MinAmount: 150,
                Enable: true,
            },
        ],
        SharingEnabled: false,
        SharingMessage: 'Would you like to share your debt?',

        //UserId: 'user/1',
        StreetNumber: '24130 Tomball Parkway',
        StreetName: 'Suite 200',
        City: 'Tomball',
        State: 'TX',
        PostalCode: '77375',
        Country: 'USA',
        //DefaultCurrencyCode: 'USD',

        enableSinglePayment: true,
    };
    isEditingCreditor: boolean = false;

    isCreditorsFetched: boolean = false;
    isPaymentTypeOptionsFetched: boolean = false;
    isIndustryOptionsFetched: boolean = false;

    public constructor(
        private appService: AppService,
        private creditorService: CreditorService,
        private cdr: ChangeDetectorRef,
    ) {}

    addMorePaymentPlan = () => {
        this.paymentPlans.push({
            Frequency: 0,
            MinAmount: 0,
            Enable: true,
        });
    };

    onDeletePaymentPlan = (index: number) => {
        this.paymentPlans = this.paymentPlans.filter((_, i) => i !== index);
    };

    addMoreCotnactPoint = () => {
        this.contactPoints.push({
            ButtonText: 'Call Now',
            ContactNumber: '',
        });
    };

    onDeleteContactPoint = (index: number) => {
        this.contactPoints = this.contactPoints.filter((_, i) => i !== index);
    };

    checkIfAllOptionsHasBeenFetched = () => {
        if (
            this.isCreditorsFetched &&
            this.isPaymentTypeOptionsFetched &&
            this.isIndustryOptionsFetched
        ) {
            this.appService.isShowPageSpinner = false;
        }
    };

    getAllCreditors = async (
        isCloseSpinner: boolean = false,
    ): Promise<void> => {
        this.appService.isShowPageSpinner = true;

        try {
            const res = await firstValueFrom(
                this.creditorService.getAllCreditors(),
            );

            this.creditors = res;
            this.originalCreditors = [...res];
            this.isSideBarVisible = false;
        } catch (error: any) {
            await firstValueFrom(this.appService.handleError(error));
        } finally {
            this.isCreditorsFetched = true;

            if (isCloseSpinner) {
                this.appService.isShowPageSpinner = false;
            } else {
                this.checkIfAllOptionsHasBeenFetched();
            }
        }
    };

    ngOnInit() {
        this.getAllCreditors();

        this.creditorService
            .getPaymentTypes()
            .pipe(
                tap(async (res: any) => {
                    this.paymentTypeOptions = [
                        { label: 'Unknown', value: 0 },
                        ...res,
                    ];
                }),
                catchError((error: any) => {
                    return this.appService.handleError(error);
                }),
                finalize(() => {
                    this.isPaymentTypeOptionsFetched = true;
                    this.checkIfAllOptionsHasBeenFetched();
                }),
            )
            .subscribe();

        this.creditorService
            .getIndustryTypes()
            .pipe(
                tap(async (res: any) => {
                    this.industryOptions = [
                        { label: 'Unknown', value: 0 },
                        ...res,
                    ].sort((a, b) => a.label.localeCompare(b.label));
                }),
                catchError((error: any) => {
                    return this.appService.handleError(error);
                }),
                finalize(() => {
                    this.isIndustryOptionsFetched = true;
                    this.checkIfAllOptionsHasBeenFetched();
                }),
            )
            .subscribe();
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.creditors);
    }

    onOpenSideBar(creditor?: any) {
        this.isEditingCreditor = !!creditor;
        this.creditorForm = { ...(creditor ?? INITIAL_CREDITOR_FORM) };
        this.validationErrors = JSON.parse(JSON.stringify(VALIDATION_ERRORS));
        this.isSideBarVisible = true;
    }

    onAddField = (field: string) => {
        this.isShowField[field] = true;
    };

    onRemoveField = (field: string) => {
        this.isShowField[field] = false;
    };

    insertCreditor = () => {
        this.appService.isShowPageSpinner = true;
        this.creditorService
            .insertCreditor(this.creditorForm)
            .pipe(
                tap((res: any) => {
                    if (res) {
                        // this.creditors = [
                        //     {
                        //         ...this.creditorForm,
                        //         creditorId: res,
                        //     },
                        //     ...this.creditors,
                        // ];

                        setTimeout(async () => {
                            await this.getAllCreditors(true);
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'New Creditor is successfully inserted.',
                            );
                        }, 1000);
                    } else {
                        this.appService.showCommonMessageDialog(
                            'Error',
                            'There seems to be an error adding new creditor. Please try again.',
                        );
                        this.appService.isShowPageSpinner = false;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {}),
            )
            .subscribe();
    };

    editCreditor = () => {
        this.appService.isShowPageSpinner = true;
        this.creditorService
            .editCreditor(this.creditorForm)
            .pipe(
                tap((res: any) => {
                    setTimeout(async () => {
                        await this.getAllCreditors(true);
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Creditor is successfully updated.',
                        );
                    }, 1000);
                }),
                catchError(this.appService.handleError),
                finalize(() => {}),
            )
            .subscribe();
    };

    validateForm = () => {
        this.validationErrors = JSON.parse(JSON.stringify(VALIDATION_ERRORS));

        const isValidBlobStorage = /^[a-z0-9-]+$/.test(
            this.creditorForm.blobStorageName,
        );

        if (!isValidBlobStorage) {
            this.validationErrors.blobStorageName =
                'Blob Storage Name has to be lowercase, no spaces, no slashes, no special characters.';
        }

        // const isValidAlertsEmailAddress = isValidEmail(
        //     this.creditorForm.alertsEmailAddress,
        // );
        // if (!isValidAlertsEmailAddress) {
        //     this.validationErrors.alertsEmailAddress =
        //         'Please input a valid alerts email address';
        // }

        // const isValidCallbackEmailAddress = isValidEmail(
        //     this.creditorForm.callbackEmailAddress,
        // );
        // if (!isValidCallbackEmailAddress) {
        //     this.validationErrors.callbackEmailAddress =
        //         'Please input a valid callback email address';
        // }

        // const isValidCallbackPhoneNumber = isValidPhoneNumber(
        //     this.creditorForm.callbackPhoneNumber,
        // );
        // if (!isValidCallbackPhoneNumber) {
        //     this.validationErrors.callbackPhoneNumber =
        //         'Please input a valid callback phone number';
        // }

        const isValidPaymentPortalUrl = isValidWebsite(
            this.creditorForm.paymentPortalUrl,
        );
        if (!isValidPaymentPortalUrl) {
            this.validationErrors.paymentPortalUrl =
                'Please input a valid payment portal url';
        }

        const isValidCompanyWebsite = isValidWebsite(this.creditorForm.website);
        if (!isValidCompanyWebsite) {
            this.validationErrors.website = 'Please input a valid website';
        }
    };

    get isAllValidationErrorsEmpty() {
        return Object.values(this.validationErrors).every(
            (value) => value === '',
        );
    }

    onSave() {
        this.validateForm();

        if (this.isAllValidationErrorsEmpty) {
            if (!this.isEditingCreditor) {
                this.insertCreditor();
            } else {
                this.editCreditor();
            }
        } else {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please resolve all validation issues first.',
            );
        }
    }

    onSelectCreditor(event: any): void {
  if (!event?.CreditorId || !event?.CompanyName) {
    this.selectedCreditorId = '';
    this.creditorCompanyName = '';
    this.creditors = [...this.originalCreditors];
    return;
  }
  this.selectedCreditorId = `creditor/${event.CreditorId}`;
  this.creditorCompanyName = event.CompanyName;
  this.creditors = this.originalCreditors.filter(
    creditor => creditor.creditorId === this.selectedCreditorId
  );
}
    

  
    
}
